
import store from '@/store'
class Config {
  get bis () {
    return store.getters['bis/authorize/configModel']
  }
}

export default new Config()
